module.exports = __webpack_public_path__ + "img/empty.ae63576e.png";